import styled from '@emotion/styled';
import {
  Category,
  Breakpoint,
  ACCESSORY_SUBCATEGORY_GROUP,
  CATEGORY_PICKER_IGNORE_GROUP,
} from 'shared/types';
import { brown, purple, transparent, yellow } from 'shared/styles/colors';
import CategoryIcon from './CategoryIcon';
import * as LayoutUtils from '../utils/LayoutUtils';
import { media } from '@mverissimoo/emotion-grid';

interface Props {
  selectedCategory: Category;
  setSelectedCategory: (selectedCategory: Category) => void;
}

const CategoryPicker = ({ selectedCategory, setSelectedCategory }: Props) => {
  const allCategories = Object.values(Category);

  const categories = allCategories.filter(
    (category) => !CATEGORY_PICKER_IGNORE_GROUP.includes(category),
  );

  const getCategoryIconColor = (category: Category) => {
    if (
      ACCESSORY_SUBCATEGORY_GROUP.includes(selectedCategory) &&
      category === Category.ACCESSORIES
    ) {
      return purple;
    }

    if (category === selectedCategory) {
      return purple;
    }

    return brown;
  };

  return (
    <OuterContainer>
      <CategoryListContainer>
        {categories.map((item) => {
          return (
            <CategoryWrapper onClick={() => setSelectedCategory(item)}>
              <CategoryIcon
                category={item}
                color={getCategoryIconColor(item)}
              />
            </CategoryWrapper>
          );
        })}
      </CategoryListContainer>
    </OuterContainer>
  );
};

export default CategoryPicker;

const OuterContainer = styled.div({
  flex: 1,
  height: '100%',
  [media(Breakpoint.lg)]: {
    height: LayoutUtils.STANDARD_SUPPORT_UI_WINDOW_HEIGHT,
  },
});

const CategoryListContainer = styled.div({
  display: 'flex',
  flexWrap: 'nowrap',
  height: '100%',
  backgroundColor: yellow,
  justifyContent: 'space-evenly',
  alignItems: 'center',
  paddingLeft: 4,
  paddingRight: 4,
  [media(Breakpoint.lg)]: {
    height: '100%',
  },
});

const CategoryWrapper = styled.button({
  width: 28,
  height: 28,
  borderWidth: 0,
  backgroundColor: transparent,
  padding: 0,
  [media(Breakpoint.lg)]: {
    width: LayoutUtils.STANDARD_SUPPORT_UI_SQUARE_SIDE,
    height: LayoutUtils.STANDARD_SUPPORT_UI_SQUARE_SIDE,
  },
});
